import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useCategoriesData } from "../../hooks/api/useCategoriesData";
import "./Navigation.css";
import { Link, useParams, useLocation } from "react-router-dom";
import { useCart } from "../../hooks/logic/useCart";

const Navigation = () => {
  const { data, isLoading } = useCategoriesData();
  const [menuOpen, setMenuOpen] = useState(false);
  let { slug } = useParams();
  const { pathname } = useLocation();

  const isFavPage = pathname.includes("favourites");
  const isCartPage = pathname.includes("cart");
  const { products } = useCart();
  const productsInCart = Array.isArray(products) ? products.length : 0;

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <div className="navigation">
        <div className="container navigation__hero">
          <Link to="/" onClick={closeMenu}>
            <img alt="Logo" className="navigation__logo"
              src="/static/images/navbar-logo.svg" />
          </Link>

          {/* Десктоп категорії */}
          <nav className="navigation__categories">
            <ul>
              {isLoading
                ? [0,1,2,3].map(key => <li key={key}><Skeleton width={40} /></li>)
                : data.map(({ attributes, id }) => {
                    const isActive = attributes.slug === slug;
                    return (
                      <li className={`navigation__link ${isActive ? "navigation__link_active" : ""}`} key={id}>
                        <Link to={`/categories/${attributes.slug}`}>{attributes.label}</Link>
                      </li>
                    );
                  })}
            </ul>
          </nav>

          <ul className="navigation__actions">
  
  {/* БЛОК КОРЗИНИ (ВИПРАВЛЕНИЙ) */}
  <li className="navigation__cart">
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <Link to="/cart">
        {/* Змінюємо іконку кошика залежно від того, чи ми на сторінці /cart */}
        <img src={isCartPage 
          ? "/static/images/shopping-cart-active.svg"  /* Фіолетова/червона активна */
          : "/static/images/shopping-cart.svg"}        /* Біла звичайна */
          alt="Cart" />
      </Link>
      
      {/* Бейдж з цифрою (відображається, якщо > 0) */}
      {productsInCart > 0 && (
        <span className="navigation__products-count">{productsInCart}</span>
      )}
    </div>
  </li>

  {/* БЛОК ОБРАНОГО (ОДИН, БЕЗ ДУБЛІКАТІВ) */}
  <li>
    <Link to="/favourites">
      <img src={isFavPage
        ? "/static/images/favourities-nav-heart-active.svg" /* Активне серце */
        : "/static/images/favourites.svg"}                   /* Звичайне серце */
        alt="Favourites" />
    </Link>
  </li>

  {/* Бургер — тільки мобайл */}
  <li className="navigation__burger" onClick={() => setMenuOpen(v => !v)}>
    <div className={`burger-icon ${menuOpen ? "burger-icon--open" : ""}`}>
      <span /><span /><span />
    </div>
  </li>
</ul>
        </div>
      </div>

      {/* Мобільний drawer */}
      <div className={`nav-drawer ${menuOpen ? "nav-drawer--open" : ""}`}>
        <nav className="nav-drawer__cats">
          <p className="nav-drawer__label">Категорії</p>
          <ul>
            {data.map(({ attributes, id }) => {
              const isActive = attributes.slug === slug;
              return (
                <li key={id} className={isActive ? "nav-drawer__link--active" : ""}>
                  <Link to={`/categories/${attributes.slug}`} onClick={closeMenu}>
                    {attributes.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        <div className="nav-drawer__bottom">
          <Link to="/favourites" className="nav-drawer__action" onClick={closeMenu}>
            <span className="nav-drawer__action-icon">
              <img src="/static/images/favourites.svg" alt="" />
            </span>
            Обране
          </Link>
          <Link to="/cart" className="nav-drawer__action" onClick={closeMenu}>
            <span className="nav-drawer__action-icon">
              <img src="/static/images/shopping-cart.svg" alt="" />
            </span>
            Кошик
            {productsInCart > 0 && (
  <span className="navigation__products-count">{productsInCart}</span>
)}
          </Link>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && <div className="nav-overlay" onClick={closeMenu} />}
    </>
  );
};

export default Navigation;
